import { h } from 'preact';
export const Image = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", ry: "2" }),
        h("circle", { cx: "8.5", cy: "8.5", r: "1.5" }),
        h("polyline", { points: "21 15 16 10 5 21" })));
};
//# sourceMappingURL=image.js.map